module.exports = __webpack_public_path__ + "img/img4.07256f2a.jpg";